/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import {getSelectedProductIdFromActionInput, ProductInput, getSimpleProductsAction } from '@msdyn365-commerce-modules/retail-actions';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { ProductWarehouses } from './AlternateItemsEntity.g';
import { getProductWarehouseInfoAsync } from './getProductWarehouseInfo.action';

/**
 * GeneraProductWarehouseDetails Input Action
 */
export class GeneraProductWarehouseDetailsInput implements Msdyn365.IActionInput {
    public productId: number;

    public channelId: number;

    public config: any;

    constructor(productId: number, channelId: number, config: any) {
        this.channelId = channelId;
        this.productId = productId;
        this.config = config;
    }


    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `GeneraProductWarehouseDetailsInput`;
    public getCacheObjectType = () => 'ProductWarehouses';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGeneraProductWarehouseDetailsData {
    warehouseDetails: ProductWarehouses[];
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (inputData: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    // return new GeneraProductWarehouseDetailsInput();
    const productId = getSelectedProductIdFromActionInput(inputData);
    if(productId)
    {
        return new GeneraProductWarehouseDetailsInput(+productId, +inputData.requestContext.apiSettings.channelId, inputData.config);

    }
    throw new Error('Unable to create SelectedVariantInput, no productId found on module config or query');
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function getCurrentProductWarehouseDetailsAction(input: GeneraProductWarehouseDetailsInput, ctx: Msdyn365.IActionContext): Promise<ProductWarehouses[]> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;
    // TODO: Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<IGeneraProductWarehouseDetailsData[]>('/get/example/id/1', 'get');
    let productWarehouseDtl:ProductWarehouses[] = [];
    const prod:ProductInput[] = new Array();
    prod.push(new ProductInput(input.productId,ctx.requestContext.apiSettings));
     var prodDtl = await getSimpleProductsAction(prod,ctx);
    const prodIds:string[] = [];
    prodIds.push(prodDtl[0].ItemId!);
     const prodWarehouseDetails = await getProductWarehouseInfoAsync({callerContext:ctx,bypassCache: 'get'},ctx,prodIds);
     if(prodWarehouseDetails && prodWarehouseDetails[0].warehouseDetails && prodWarehouseDetails[0].warehouseDetails?.value)
    {
        productWarehouseDtl = prodWarehouseDetails[0].warehouseDetails?.value;
    }
    return productWarehouseDtl;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ProductWarehouses[]>>getCurrentProductWarehouseDetailsAction,
    // TODO: Give your data action a unique id
    id: 'getCurrentProductWarehouseDetailsAction',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
